import {
  inferAdditionalFields,
  usernameClient,
} from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import config from 'config';
import { SERVER_AUTH_BASE_PATH } from 'business/auth/constants';

export const authClient = createAuthClient({
  baseURL: config.baseUrl,
  basePath: SERVER_AUTH_BASE_PATH,
  plugins: [
    usernameClient(),
    inferAdditionalFields({
      user: {
        projectId: {
          type: 'string',
          required: true,
        },
      },
    }),
  ],
});

export type Session = typeof authClient.$Infer.Session;
export const { useSession, signIn, signUp, signOut } = authClient;
